import { Action } from '@ngrx/store';
import { ActionOptionsArgs, BaseAction, SynchronisableAction } from '../../../core/store/actions/base-actions';
import { DefaultTask } from './default-task.model';
import { IDefaultTaskFilters } from './default-task.reducer';

export const ENTITY = 'defaultTask';
export const SUBMIT = '[DefaultTask] Submit';
export const REHYDRATE = '[DefaultTask] Rehydrate';
export const REMOVE = '[DefaultTask] Remove';
export const SET_FILTER = '[DefaultTask] Set Filter';
export const SET_TOTAL = '[DefaultTask] Set Total';
export const LOAD_NEXT_PAGE = '[DefaultTask] Load Next Page';

export class SubmitAction extends SynchronisableAction {
    readonly entity = ENTITY;
    readonly type = SUBMIT;

    constructor(public payload: DefaultTask, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class RehydrateAction implements Action {
    readonly entity = ENTITY;
    readonly type = REHYDRATE;

    constructor(public payload: Array<DefaultTask>) {

    }
}

export class RemoveAction extends SynchronisableAction {
    readonly type = REMOVE;
    readonly entity = ENTITY;

    constructor(public payload: DefaultTask, options?: ActionOptionsArgs) {
        super(payload, options);
    }

    getKey(): string {
        return `${this.entity}:entity:${this.payload.id}`;
    }
}

export class SetFilterAction extends BaseAction {
    readonly type = SET_FILTER;
    readonly entity = ENTITY;

    constructor(public payload: IDefaultTaskFilters, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export class SetTotalAction extends BaseAction {
    readonly type = SET_TOTAL;
    readonly entity = ENTITY;

    constructor(public payload: number, options?: ActionOptionsArgs) {
        super(payload, options);
    }
}

export class LoadNextPage extends BaseAction {
    readonly type = LOAD_NEXT_PAGE;
    readonly entity = ENTITY;

    constructor() {
        super(undefined);
    }
}

export type Actions
    = SubmitAction
    | RehydrateAction
    | RemoveAction
    | SetFilterAction
    | SetTotalAction
    | LoadNextPage;



// WEBPACK FOOTER //
// ./src/vas/business-objects/default-task/default-task.actions.ts